import React from "react";

const QuotationHeader = ({ quotation }) => {
  const organization = quotation?.organization || {};

  return (
    <header className="quotation-header">
      <div className="quotation-header-inner">
        <div className="quotation-brand">
          {organization.logoUrl ? (
            <img
              src={organization.logoUrl}
              alt={organization.name || "Company Logo"}
              className="quotation-logo-image"
            />
          ) : (
            <div>
              <h1>{organization.name || "PristinePV"}</h1>

              <span>Solar Inspection & Services</span>
            </div>
          )}
        </div>

        <div className="quotation-title">
          <span>QUOTATION</span>

          <strong>#{quotation?.quotationNumber || "-"}</strong>
        </div>
      </div>
    </header>
  );
};

export default QuotationHeader;